import login from "@/api/login";
import jwt_decode from "jwt-decode";
import store from "..";
import reservePlanService from "../../api/reservePlan.service";
import reservePlanServiceNew from "../../api/reservePlanNew.service";

const user = {
  state: {
    customerAccessCodes: [],
    permissions: [],
    token: "",
    refreshToken: "",
    tokenExpiryTime: "",
    roles: "",
    user: "",
    name: "",
    userId: "",
    id: "",
    customerId: "",
    referenceId: "",
    reportvalue: "",
    auditFinanceCustomer: "",
    auditFinanceFromDate: "",
    auditFinanceToDate: "",
    FinanceCustomerName: "",
    ToolsComName: "",
    ToolsCustomerId: "",
    ToolsapiToken: "",
    AppSheetToolsComName: "",
    AppSheetToolsCustomerId: "",
    AppSheetToolsapiToken: "",
    reportId: "",
    companyName: "",
    companyNameDropdown: "",
    companyIdDropdown: "",
    supportTicketsReferenceId: "",
    assetWizardValue: "",
    serviceWizardValue: "",
    assetRefreshVal: "",
    serviceRefreshVal: "",
    activeTab: "",
    assetBatchId: "",
    serviceBatchId: "",
    pageNumber: 1,
    pageSize: -1,
    basicCustomers: [],
    masterItems: [],
    activeToggleBtnVal: "",
    activeContractsToggleBtnVal: "",
    activeContractsMapToggleBtnVal: "",
    serviceRecordsToggle: 0,
    // RamaSneha,
    planningSheetObj: {},
    smsCNum: "",
    smsUserPermissions: {},
    smsCustomerId: "",
    smsUserId: "",
    storeReserveSMSStepVal: 1,
    storeProjectionID: "",
    storeProjectionItemEquipment: "",
    storeProjectionItemID: "",
    storeReserveType: "",
    showSMSLeftNav: false,
    createPlanningSheetTab: 1,
    createPlanningSheetTabPrev: null,

    createdSheetObj: {},
    showFinalImageDescFromProjectionItemsCreationSheet: false,
    equipmentImgDetails: {},
    isReviewImage: false,
    serviceModuleStepModel: 1,
    serviceTemlateDetails: {},
    projectionItemRoute: "",
    suggestedProjectionItemId: "",
    copyOfProjectionName: "",
    smsCustomerLinkingId: "",
    smsBirchLinkingId: "",
    smsAuthToken: "",
    accessTabsVal: "",
    firstTimeLogin: false,
    twoFactorEnabled: false,
    phoneNumber: null,
    phoneCountryCode: null,
    profilePicture: null,
  },
  // this.$store.dispatch("ToolsComName", this.compName);
  // this.$store.dispatch("ToolsCustomerId", this.Id);
  // this.$store.dispatch("ToolsapiToken", this.apiToken);
  getters: {
    token: (state) => state.token,
    refreshToken: (state) => state.refreshToken,
    tokenExpiryTime: (state) => state.tokenExpiryTime,
    roles: (state) => state.roles,
    customerAccessCodes: (state) => state.customerAccessCodes,
    permissions: (state) => state.permissions,
    name: (state) => state.name,
    fullname: (state) => state.fullname,
    user: (state) => state.user,
    userId: (state) => state.userId,
    id: (state) => state.id,
    customerId: (state) => state.customerId,
    referenceId: (state) => state.referenceId,
    avatar: () => null,
    addressText: (state) => state.addressText,
    accNo: (state) => state.accNo,
    lastLoginTime: (state) => state.lastLoginTime,

    reportvalue: (state) => state.reportvalue,
    auditFinanceCustomer: (state) => state.auditFinanceCustomer,
    auditFinanceFromDate: (state) => state.auditFinanceFromDate,
    auditFinanceToDate: (state) => state.auditFinanceToDate,
    FinanceCustomerName: (state) => state.FinanceCustomerName,
    ToolsComName: (state) => state.ToolsComName,
    ToolsCustomerId: (state) => state.ToolsCustomerId,
    ToolsapiToken: (state) => state.ToolsapiToken,
    AppSheetToolsComName: (state) => state.AppSheetToolsComName,
    AppSheetToolsCustomerId: (state) => state.AppSheetToolsCustomerId,
    AppSheetToolsapiToken: (state) => state.AppSheetToolsapiToken,
    reportId: (state) => state.reportId,
    companyName: (state) => state.companyName,
    companyNameDropdown: (state) => state.companyNameDropdown,
    companyIdDropdown: (state) => state.companyIdDropdown,

    supportTicketsReferenceId: (state) => state.supportTicketsReferenceId,
    assetWizardValue: (state) => state.assetWizardValue,
    serviceWizardValue: (state) => state.serviceWizardValue,
    assetRefreshVal: (state) => state.assetRefreshVal,
    serviceRefreshVal: (state) => state.serviceRefreshVal,
    activeTab: (state) => state.activeTab,
    assetBatchId: (state) => state.assetBatchId,
    serviceBatchId: (state) => state.serviceBatchId,
    pageNumber: (state) => state.pageNumber,
    pageSize: (state) => state.pageSize,
    basicCustomers: (state) => state.basicCustomers,
    masterItems: (state) => state.masterItems,
    activeToggleBtnVal: (state) => state.activeToggleBtnVal,
    activeContractsToggleBtnVal: (state) => state.activeContractsToggleBtnVal,
    planningSheetObj: (state) => state.planningSheetObj,
    smsCNum: (state) => state.smsCNum,
    smsUserPermissions: (state) => state.smsUserPermissions,

    smsCustomerId: (state) => state.smsCustomerId,
    smsUserId: (state) => state.smsUserId,
    storeReserveSMSStepVal: (state) => state.storeReserveSMSStepVal,
    storeProjectionID: (state) => state.storeProjectionID,
    storeProjectionItemEquipment: (state) => state.storeProjectionItemEquipment,
    storeProjectionItemID: (state) => state.storeProjectionItemID,
    storeReserveType: (state) => state.storeReserveType,
    showSMSLeftNav: (state) => state.showSMSLeftNav,
    profilePicture: (state) => state.profilePicture,
    createPlanningSheetTab: (state) => state.createPlanningSheetTab,
    createPlanningSheetTabPrev: (state) => state.createPlanningSheetTabPrev,

    serviceModuleStepModel: (state) => state.serviceModuleStepModel,
    serviceTemlateDetails: (state) => state.serviceTemlateDetails,
    //  createdSheetObj: (state) => state.createdSheetObj,
    //  showFinalImageDescFromProjectionItemsCreationSheet: (state) => state.showFinalImageDescFromProjectionItemsCreationSheet,
    //  equipmentImgDetails: (state) => state.equipmentImgDetails,
    isReviewImage: (state) => state.isReviewImage,
    serviceRecordsToggle: (state) => state.serviceRecordsToggle,
    projectionItemRoute: (state) => state.projectionItemRoute,
    suggestedProjectionItemId: (state) => state.suggestedProjectionItemId,
    copyOfProjectionName: (state) => state.copyOfProjectionName,
    smsCustomerLinkingId: (state) => state.smsCustomerLinkingId,
    smsBirchLinkingId: (state) => state.smsBirchLinkingId,
    smsAuthToken: (state) => state.smsAuthToken,
    accessTabsVal: (state) => state.accessTabsVal,
    smsOrderBy: (state) => state.smsOrderBy,
    smsPickedUpBy: (state) => state.smsPickedUpBy,
    shift: (state) => state.shift,
    deliveryRequired: (state) => state.deliveryRequired,
    firstTimeLogin: (state) => state.firstTimeLogin,
    twoFactorEnabled: (state) => state.twoFactorEnabled,
    phoneNumber: (state) => state.phoneNumber,
    phoneCountryCode: (state) => state.phoneCountryCode,
  },

  mutations: {
    SET_USER_INFO: (state, payload) => {
      if (payload.logout) {
        window.localStorage.setItem("masterItems", JSON.stringify([]));
        window.localStorage.setItem("custpermission", JSON.stringify([]));

        // window.localStorage.removeItem("custpermission", []);
        state.customerAccessCodes = [];
        state.permissions = [];
        state.token = "";
        (state.refreshToken = ""),
          (state.tokenExpiryTime = ""),
          (state.roles = "");
        state.user = "";
        state.name = "";
        state.fullname = "";
        state.userId = "";
        state.addressText = "";
        state.companyName = "";
        (state.companyNameDropdown = ""),
          (state.companyIdDropdown = ""),
          (state.accNo = "");
        state.lastLoginTime = "";
        state.smsOrderBy = "";
        state.smsPickedUpBy = "";
        state.shift = "";
        state.deliveryRequired = Boolean;
        state.id = "";
        state.customerId = "";
        state.referenceId = "";
        state.reportvalue = "";
        state.auditFinanceCustomer = "";
        state.auditFinanceFromDate = "";
        state.auditFinanceToDate = "";
        state.FinanceCustomerName = "";
        state.ToolsComName = "";
        state.ToolsCustomerId = "";
        state.ToolsapiToken = "";
        (state.AppSheetToolsComName = ""),
          (state.AppSheetToolsCustomerId = ""),
          (state.AppSheetToolsapiToken = ""),
          (state.reportId = ""),
          (state.companyName = "");
        state.companyIdPermission = "";
        (state.companyNameDropdown = ""),
          (state.companyIdDropdown = ""),
          (state.supportTicketsReferenceId = "");
        state.assetWizardValue = "";
        state.serviceWizardValue = "";
        state.assetRefreshVal = "";
        state.serviceRefreshVal = "";
        state.activeTab = "";
        state.assetBatchId = "";
        state.serviceBatchId = "";
        state.pageNumber = "";
        state.pageSize = "";
        state.basicCustomers = [];
        state.masterItems = [];
        state.activeToggleBtnVal = "";
        state.activeContractsToggleBtnVal = "";
        // RamaSneha,
        state.planningSheetObj = {};
        state.smsCNum = "";
        state.smsUserPermissions = {};
        state.smsCustomerId = "";
        state.smsUserId = "";
        state.storeReserveSMSStepVal = 1;
        state.storeProjectionID = "";
        state.storeProjectionItemEquipment = "";
        state.storeProjectionItemID = "";
        state.storeReserveType = "";
        state.showSMSLeftNav = "";
        (state.profilePicture = null), (state.createPlanningSheetTab = 1);
        state.createPlanningSheetTabPrev = null;
        //  state.createdSheetObj = {};
        //  state.showFinalImageDescFromProjectionItemsCreationSheet = false;
        //  state.equipmentImgDetails = {};
        state.isReviewImage = false;
        state.serviceModuleStepModel = 1;
        state.serviceTemlateDetails = {};
        state.serviceRecordsToggle = 0;
        state.projectionItemRoute = "";
        state.suggestedProjectionItemId = "";
        state.copyOfProjectionName = "";
        state.smsCustomerLinkingId = "";
        state.smsBirchLinkingId = "";
        state.smsAuthToken = "";
        state.accessTabsVal = 0;
        state.firstTimeLogin = false;
        state.twoFactorEnabled = false;
        state.phoneNumber = null;
        state.phoneCountryCode = null;
      } else {
        state.customerAccessCodes = payload.customerAccessCodes || [];
        state.token = payload.token || state.token;
        state.roles = payload.role || state.role;
        state.user = payload.sub || state.sub;
        state.name = payload.firstName || state.firstName;
        state.fullname =
          payload.firstName.trim() + " " + payload.lastName ||
          state.firstName.trim() + " " + state.lastName;
        state.smsOrderBy = payload.smsOrderBy || state.smsOrderBy;
        state.smsPickedUpBy = payload.smsPickedUpBy || state.smsPickedUpBy;
        state.shift = payload.shift || state.shift;
        state.deliveryRequired =
          payload.deliveryRequired || state.deliveryRequired;
        state.permissions = payload.permissions || state.permissions;
        state.userId = payload.userId || state.userId;
        state.addressText = payload.addressText || state.addressText;
        state.companyName = payload.companyName || state.companyName;
        (state.companyIdPermission =
          payload.companyIdPermission || state.companyIdPermission),
          (state.companyNameDropdown =
            payload.companyNameDropdown || state.companyNameDropdown);
        state.companyIdDropdown =
          payload.companyIdDropdown || state.companyIdDropdown;
        state.accNo = payload.accNo || state.accNo;
        state.lastLoginTime = payload.lastLoginTime || state.lastLoginTime;
        state.id = payload.id || state.id;
        state.customerId = payload.customerId || state.customerId;
        state.referenceId = payload.referenceId || state.referenceId;
        state.reportvalue = payload.reportvalue || state.reportvalue;
        state.auditFinanceCustomer =
          payload.auditFinanceCustomer || state.auditFinanceCustomer;
        state.auditFinanceFromDate =
          payload.auditFinanceFromDate || state.auditFinanceFromDate;
        state.auditFinanceToDate =
          payload.auditFinanceToDate || state.auditFinanceToDate;
        state.FinanceCustomerName =
          payload.FinanceCustomerName || state.FinanceCustomerName;
        state.ToolsComName = payload.ToolsComName || state.ToolsComName;
        state.ToolsCustomerId =
          payload.ToolsCustomerId || state.ToolsCustomerId;
        state.ToolsapiToken = payload.ToolsapiToken || state.ToolsapiToken;
        (state.AppSheetToolsComName =
          payload.AppSheetToolsComName || state.AppSheetToolsComName),
          (state.AppSheetToolsCustomerId =
            payload.AppSheetToolsCustomerId || state.AppSheetToolsCustomerId),
          (state.AppSheetToolsapiToken =
            payload.AppSheetToolsapiToken || state.AppSheetToolsapiToken),
          (state.reportId = payload.reportId || state.reportId),
          (state.companyName = payload.companyName || state.companyName);
        (state.companyIdPermission =
          payload.companyIdPermission || state.companyIdPermission),
          (state.companyNameDropdown =
            payload.companyNameDropdown || state.companyNameDropdown);
        state.companyIdDropdown =
          payload.companyIdDropdown || state.companyIdDropdown;
        state.supportTicketsReferenceId =
          payload.supportTicketsReferenceId || state.supportTicketsReferenceId;
        state.assetWizardValue =
          payload.assetWizardValue || state.assetWizardValue;
        state.serviceWizardValue =
          payload.serviceWizardValue || state.serviceWizardValue;
        state.assetRefreshVal =
          payload.assetRefreshVal || state.assetRefreshVal;
        state.serviceRefreshVal =
          payload.serviceRefreshVal || state.serviceRefreshVal;
        state.activeTab = payload.activeTab || state.activeTab;
        state.assetBatchId = payload.assetBatchId || state.assetBatchId;
        state.serviceBatchId = payload.serviceBatchId || state.serviceBatchId;
        state.pageNumber = payload.pageNumber || state.pageNumber;
        state.pageSize = payload.pageSize || state.pageSize;

        state.basicCustomers = payload.basicCustomers || state.basicCustomers;
        state.masterItems = payload.masterItems || state.masterItems;
        state.activeToggleBtnVal =
          payload.activeToggleBtnVal || state.activeToggleBtnVal;
        state.activeContractsToggleBtnVal =
          payload.activeContractsToggleBtnVal ||
          state.activeContractsToggleBtnVal;
        // RamaSneha,
        state.planningSheetObj =
          payload.planningSheetObj || state.planningSheetObj;
        state.smsCNum = payload.smsCNum || state.smsCNum;
        state.smsCustomerId = payload.smsCustomerId || state.smsCustomerId;
        state.smsUserId = payload.smsUserId || state.smsUserId;
        state.storeReserveSMSStepVal =
          payload.storeReserveSMSStepVal || state.storeReserveSMSStepVal;
        state.storeProjectionID =
          payload.storeProjectionID || state.storeProjectionID;
        state.storeProjectionItemEquipment =
          payload.storeProjectionItemEquipment ||
          state.storeProjectionItemEquipment;
        state.storeProjectionItemID =
          payload.storeProjectionItemID || state.storeProjectionItemID;
        state.storeReserveType =
          payload.storeReserveType || state.storeReserveType;
        state.showSMSLeftNav = payload.showSMSLeftNav || state.showSMSLeftNav;
        state.profilePicture = payload.profilePicture || state.profilePicture;
        state.createPlanningSheetTab =
          payload.createPlanningSheetTab || state.createPlanningSheetTab;
        state.createPlanningSheetTabPrev =
          payload.createPlanningSheetTabPrev ||
          state.createPlanningSheetTabPrev;
        //  state.createdSheetObj = payload.createdSheetObj || state.createdSheetObj;
        //  state.showFinalImageDescFromProjectionItemsCreationSheet = payload.showFinalImageDescFromProjectionItemsCreationSheet || state.showFinalImageDescFromProjectionItemsCreationSheet;
        //  state.equipmentImgDetails = payload.equipmentImgDetails || state.equipmentImgDetails;
        state.isReviewImage = payload.isReviewImage || state.isReviewImage;
        state.serviceModuleStepModel =
          payload.serviceModuleStepModel || state.serviceModuleStepModel;
        state.serviceTemlateDetails =
          payload.serviceTemlateDetails || state.serviceTemlateDetails;
        state.serviceRecordsToggle =
          payload.serviceRecordsToggle || state.serviceRecordsToggle;
        state.projectionItemRoute =
          payload.projectionItemRoute || state.projectionItemRoute;
        state.suggestedProjectionItemId =
          payload.suggestedProjectionItemId || state.suggestedProjectionItemId;
        state.copyOfProjectionName =
          payload.copyOfProjectionName || state.copyOfProjectionName;
        state.smsCustomerLinkingId =
          payload.smsCustomerLinkingId || state.smsCustomerLinkingId;
        state.smsBirchLinkingId =
          payload.smsBirchLinkingId || state.smsBirchLinkingId;
        state.smsAuthToken = payload.smsAuthToken || state.smsAuthToken;
        state.accessTabsVal = payload.accessTabsVal || state.accessTabsVal;
        state.firstTimeLogin = payload.firstTimeLogin || state.firstTimeLogin;
        state.twoFactorEnabled =
          payload.twoFactorEnabled || state.twoFactorEnabled;
        state.phoneNumber = payload.phoneNumber || state.phoneNumber;
        state.phoneCountryCode =
          payload.phoneCountryCode || state.phoneCountryCode;
      }
    },
    SET_ACCESS_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_REFRESH_TOKEN: (state, refreshToken) => {
      state.refreshToken = refreshToken;
    },
    SET_TOKEN_EXPIRY_TIME: (state, tokenExpiryTime) => {
      state.tokenExpiryTime = tokenExpiryTime;
    },
    REPORT_VALUE: (state, value) => {
      state.reportvalue = value;
    },
    REFERENCE_ID: (state, value) => {
      state.referenceId = value;
    },
    SET_Customer: (state, value) => {
      state.auditFinanceCustomer = value;
    },
    SET_FromDate: (state, value) => {
      state.auditFinanceFromDate = value;
    },
    SET_ToDate: (state, value) => {
      state.auditFinanceToDate = value;
    },
    SET_CUSTOMERNAME: (state, value) => {
      state.FinanceCustomerName = value;
    },
    SET_TOOL_COMNAME: (state, value) => {
      state.ToolsComName = value;
    },
    SET_TOOL_CUSTOMERID: (state, value) => {
      state.ToolsCustomerId = value;
    },
    SET_TOOL_APITOKEN: (state, value) => {
      state.ToolsapiToken = value;
    },
    SET_APPSHEET_COMNAME: (state, value) => {
      state.AppSheetToolsComName = value;
    },
    SET_APPSHEET_CUSTOMERID: (state, value) => {
      state.AppSheetToolsCustomerId = value;
    },
    SET_APPSHEET_APITOKEN: (state, value) => {
      state.AppSheetToolsapiToken = value;
    },
    SET_REPORTID: (state, value) => {
      state.reportId = value;
    },
    SET_COMPANYNAME: (state, value) => {
      state.companyName = value;
    },
    SET_COMPANYNAMEDROPDOWN: (state, value) => {
      state.companyNameDropdown = value;
    },
    SET_COMPANYIDDROPDOWN: (state, value) => {
      state.companyIdDropdown = value;
    },

    SET_SUPPORT_REF_ID: (state, value) => {
      state.supportTicketsReferenceId = value;
    },
    SET_ASSET_WIZARD_VALUE: (state, value) => {
      state.assetWizardValue = value;
    },
    SET_SERVICE_WIZARD_VALUE: (state, value) => {
      state.serviceWizardValue = value;
    },
    SET_ASSET_REFRESH_VAL: (state, value) => {
      state.assetRefreshVal = value;
    },
    SET_SERVICE_REFRESH_VAL: (state, value) => {
      state.serviceRefreshVal = value;
    },
    SET_ACTIVE_TAB: (state, value) => {
      state.activeTab = value;
    },
    // assetBatchId
    SET_ASSET_BATCH_ID: (state, value) => {
      state.assetBatchId = value;
    },
    // serviceBatchId
    SET_SERVICE_BATCH_ID: (state, value) => {
      state.serviceBatchId = value;
    },
    SET_PAGE_NUMBER: (state, value) => {
      state.pageNumber = value;
    },
    SET_PAGE_SIZE: (state, value) => {
      state.pageSize = value;
    },
    SET_BASIC_CUSTOMERS: (state, value) => {
      state.basicCustomers = value;
      // console.log(value);
    },
    SET_MASTER_ITEMS: (state, value) => {
      state.masterItems = value;
      // console.log(value);
    },
    SET_ACTIVE_TOGGLE_VAL: (state, value) => {
      state.activeToggleBtnVal = value;
    },
    SET_ACTIVE_CONTRACTS_TOGGLE_VAL: (state, value) => {
      state.activeContractsToggleBtnVal = value;
    },
    // RamaSneha,
    SET_PLANNING_SHEET_OBJ: (state, value) => {
      state.planningSheetObj = value;
    },
    SET_SMS_CNUM: (state, value) => {
      state.smsCNum = value;
    },
    SET_SMS_USER_PERMISSIONS: (state, value) => {
      state.smsUserPermissions = value;
    },
    SET_SMS_CUSTOMER_ID: (state, value) => {
      state.smsCustomerId = value;
    },
    SET_SMS_USER_ID: (state, value) => {
      state.smsUserId = value;
    },
    SET_RESERVE_SMS_STEP_VAL: (state, value) => {
      state.storeReserveSMSStepVal = value;
    },
    SET_STORE_PROJECTION_ID: (state, value) => {
      state.storeProjectionID = value;
    },
    SET_STORE_PROJECTION_ITEM_EQUIPMENT: (state, value) => {
      state.storeProjectionItemEquipment = value;
    },
    SET_STORE_PROJECTION_ITEM_ID: (state, value) => {
      state.storeProjectionItemID = value;
    },
    SET_STORE_RESERVE_TYPE: (state, value) => {
      state.storeReserveType = value;
    },
    SET_SHOW_SMS_LEFT_NAV: (state, value) => {
      state.showSMSLeftNav = value;
    },
    SET_PROFILE_PICTURE: (state, value) => {
      state.profilePicture = value;
    },
    SET_PLANNING_SHEET_TAB: (state, value) => {
      state.createPlanningSheetTab = value;
    },
    SET_PLANNING_SHEET_TAB_PREV: (state, value) => {
      state.createPlanningSheetTabPrev = value;
    },
    // SET_CREATED_SHEET_OBJ: (state, value) => {
    //   state.createdSheetObj = value;
    // },
    // SET_FINAL_IMAGE_DESC: (state, value) => {
    //   state.showFinalImageDescFromProjectionItemsCreationSheet = value;
    // },
    // SET_EQIP_IMG_DETAILS: (state, value) => {
    //   state.equipmentImgDetails = value;
    // },
    SET_IS_REVIEW_IMAGE: (state, value) => {
      state.isReviewImage = value;
    },
    SET_SERVICE_MODULE_STEP_MODEL: (state, value) => {
      state.serviceModuleStepModel = value;
    },
    SET_SERVICE_TEMPLATE_DETAILS: (state, value) => {
      state.serviceTemlateDetails = value;
    },
    SET_SERVICE_RECORDS_TOGGLE: (state, value) => {
      state.serviceRecordsToggle = value;
    },
    SET_PROJECTION_ROUTE: (state, value) => {
      state.projectionItemRoute = value;
    },
    SET_SUGGESTED_PROJECTION_ITEM_ID: (state, value) => {
      state.suggestedProjectionItemId = value;
    },
    SET_COPY_PROJECTION_NAME: (state, value) => {
      state.copyOfProjectionName = value;
    },
    SET_CUSTOMER_LINKING_ID: (state, value) => {
      state.smsCustomerLinkingId = value;
    },
    SET_BIRCH_LINKING_ID: (state, value) => {
      state.smsBirchLinkingId = value;
    },
    SET_SMS_ACCESS_TOKEN: (state, value) => {
      state.smsAuthToken = value;
    },
    SET_ACCESS_TAB_VAL: (state, value) => {
      state.accessTabsVal = value;
    },
    SET_SMS_ORDER_BY: (state, value) => {
      state.smsOrderBy = value;
    },
    SET_SMS_PICKEDUP_BY: (state, value) => {
      state.smsPickedUpBy = value;
    },
    SET_SHIFT: (state, value) => {
      state.shift = value;
    },
    SET_DELIVERY_REQUIRED: (state, value) => {
      state.deliveryRequired = value;
    },
    SET_FIRST_TIME_LOGIN: (state, value) => {
      state.firstTimeLogin = value;
    },
    SET_TWO_FACTOR_ENABLED: (state, value) => {
      state.twoFactorEnabled = value;
    },
    SET_PHONE_NUMBER: (state, value) => {
      state.phoneNumber = value;
    },
  },

  actions: {
    // Login user dispatch
    LoginByEmail: async ({ commit, dispatch }, payload) => {
      try {
        const response = await login.loginByEmail(
          payload.userName.trim(),
          payload.password,
          payload.grant_type
        );
        if (response.isSuccess) {
          await commit(
            "SET_ACCESS_TOKEN",
            response.data.authToken.access_token
          );
          await commit(
            "SET_REFRESH_TOKEN",
            response.data.authToken.refresh_token
          );
          await commit(
            "SET_TOKEN_EXPIRY_TIME",
            response.data.authToken.expires_at
          );
          //  //For  items data for sms
          //   dispatch("GetItemsInfo");
          let token = response.data.authToken.access_token;
          let userAccountInfo = jwt_decode(token);
          if (JSON.stringify(userAccountInfo) !== "{}") {
            userAccountInfo.firstName = userAccountInfo.firstName + " ";
            userAccountInfo.phoneNumber = response.data.userAccount.phoneNumber;
            userAccountInfo.firstTimeLogin =
              response.data.userAccount.needtoChangePassword;
            userAccountInfo.twoFactorEnabled =
              response.data.userAccount.twoFactorEnabled;
            userAccountInfo.phoneCountryCode =
              response.data.userAccount.phoneCountryCode;
            if (response.data.userAccount.role == "Admin") {
              if (
                response.data.userAccount.permissions == null ||
                response.data.userAccount.permissions != null
              ) {
                userAccountInfo.permissions = [];
                userAccountInfo.permissions = [
                  "Overview",
                  "Map",
                  "On Rent Equipment",
                  "Birch Fleet",
                  "Customer Owned Equipment",
                  "Contracts",
                  "Service & Maintenance",
                  "Reserve & Order",
                  "Alerts Management",
                  "Reports",
                  "View All Reports",
                  "Utilization Report - Detailed",
                  "Existing Active Alerts",
                  "Scheduled",
                  "On Rent",
                  "On Reservation",
                  "Overdue",
                  // "Scheduled for Pickup",
                  "New Operational",
                  "Trip",
                  "Incident",
                  "Activity",
                  "Actual Spend To Date",
                  "Off Rent",
                  "SMS On Rent",
                  "On Rent With Spend Analysis",
                  "Planned Vs Actual",
                  "Rent To Date And Projected",
                  "Items Rented",
                  "Active Maintenance",
                  "Historical Maintenance",
                  "Customer Balance",
                  "SMS Alerts",
                  "Settings",
                  "Admin",
                  "Service Call",
                  "Access Control Codes",
                  "Access Control",
                  "Utilization",
                  "Logout",
                ];
              }
            } else if (response.data.userAccount.role == "Birch User") {
              if (
                response.data.userAccount.permissions == null ||
                response.data.userAccount.permissions != null
              ) {
                userAccountInfo.permissions = [];
                userAccountInfo.permissions = [
                  "Overview",
                  "Map",
                  "On Rent Equipment",
                  "Birch Fleet",
                  "Customer Owned Equipment",
                  "Contracts",
                  "Service & Maintenance",
                  "Reserve & Order",
                  "Alerts Management",
                  "Reports",
                  "View All Reports",
                  "Utilization Report - Detailed",
                  "Existing Active Alerts",
                  "Scheduled",
                  "On Rent",
                  "On Reservation",
                  "Overdue",
                  // "Scheduled for Pickup",
                  "New Operational",
                  "Trip",
                  "Incident",
                  "Activity",
                  "Actual Spend To Date",
                  "Off Rent",
                  "SMS On Rent",
                  "On Rent With Spend Analysis",
                  "Planned Vs Actual",
                  "Rent To Date And Projected",
                  "Items Rented",
                  "Active Maintenance",
                  "Historical Maintenance",
                  "Customer Balance",
                  "SMS Alerts",
                  "Settings",
                  "Service Call",
                  "Access Control Codes",
                  "Access Control",
                  "Utilization",
                  "Logout",
                ];
              }
            } else if (
              response.data.userAccount.role != "Admin" &&
              response.data.userAccount.role != "Birch User" &&
              response.data.userAccount.permissions != null &&
              response.data.userAccount.permissions != ""
            ) {
              userAccountInfo.permissions =
                response.data.userAccount.permissions.split(",");
            } else if (
              response.data.userAccount.role != "Admin" &&
              response.data.userAccount.role != "Birch User" &&
              (response.data.userAccount.permissions == null) |
                (response.data.userAccount.permissions == "")
            ) {
              userAccountInfo.permissions = [];
              userAccountInfo.permissions = ["Overview", "Logout"];
            }
            let companyInfo = response.data.company;
            let userInfo = response.data.userAccount;
            let custdatapermission = [];

            custdatapermission.push(response.data.customerIds);
            companyInfo.addressText =
              companyInfo.address.city +
              ", " +
              companyInfo.address.state +
              " " +
              companyInfo.address.zip;
            userAccountInfo.addressText = companyInfo.addressText;

            window.localStorage.setItem(
              "custpermission",
              JSON.stringify(response.data.customerIds)
            );

            userAccountInfo.companyName = companyInfo.name;
            userAccountInfo.accNo = companyInfo.accountNumber;
            userAccountInfo.companyIdPermission = companyInfo.id;

            userAccountInfo.lastLoginTime = userInfo.lastLoginTime;
            userAccountInfo.smsCustomerId = userInfo.smsCustomerId;
            userAccountInfo.smsUserId = userInfo.smsUserId;
            userAccountInfo.smsAuthToken = userInfo.smsAuthToken;

            userAccountInfo.pickedUpBy = userInfo.pickedUpBy;
            userAccountInfo.orderBy = userInfo.orderBy;
            userAccountInfo.shift = userInfo.shift;
            userAccountInfo.deliveryRequired = userInfo.deliveryRequired;
            userAccountInfo.customerAccessCodes = userInfo.customerAccessCodes;
            await commit("SET_PROFILE_PICTURE", userInfo.profilePicture);
            // console.log(userInfo.smsAuthToken);
            if (userAccountInfo.smsCustomerId && userAccountInfo.smsUserId) {
              await commit("SET_SHOW_SMS_LEFT_NAV", true);
            }
            //

            await commit("SET_USER_INFO", userAccountInfo);
            if (
              response.data.userAccount &&
              response.data.userAccount.userProfileDetails &&
              response.data.userAccount.userProfileDetails.planningSheetSettings
            ) {
              await commit(
                "SET_SMS_USER_PERMISSIONS",
                response.data.userAccount.userProfileDetails
                  .planningSheetSettings
              );
            } else {
              await commit("SET_SMS_USER_PERMISSIONS", {});
            }
            dispatch("GetCNumVal");

            return true;
          } else {
            return true;
          }
        }
      } catch (err) {
        console.warn("[vuex.user] LoginByEmail", err);
      }
    },
    GetItemsInfo: async ({ commit }) => {
      await commit("SET_IS_REVIEW_IMAGE", true);
      try {
        const response = await reservePlanServiceNew.getItemsList();
        // if (response) {

        if (response.data) {
          // SET_IS_REVIEW_IMAGE
          // await commit(
          //   "SET_MASTER_ITEMS",
          //   response
          // );
          await window.localStorage.setItem(
            "masterItems",
            JSON.stringify(response.data)
          );
          await commit("SET_IS_REVIEW_IMAGE", false);
        } else {
          // await commit(
          //   "SET_MASTER_ITEMS",
          //   []
          // );
          await window.localStorage.setItem("masterItems", JSON.stringify([]));
          await commit("SET_IS_REVIEW_IMAGE", false);
        }
        // }
      } catch (err) {
        await window.localStorage.setItem("masterItems", JSON.stringify([]));
        await commit("SET_IS_REVIEW_IMAGE", false);
        console.warn("[vuex.user] GetItemsInfo", err);
        return false;
      }
    },
    GetCNumVal: async ({ commit }) => {
      try {
        const response = await reservePlanService.getcustomer();
        if (response) {
          if (response) {
            let CNum;
            response.filter((item) => {
              if (item.BirchCustomerID == store.getters.smsCustomerId) {
                CNum = item.CustomerCNUM;
              }
            });
            await commit("SET_SMS_CNUM", CNum);
          }
        }
      } catch (err) {
        console.warn("[vuex.user] GetCNumVal", err);
        return false;
      }
    },

    GetUserPermissionsByBirchCustomerId: async ({ commit }) => {
      try {
        const response =
          await reservePlanService.getUserPermissionsByBirchCustomerId(
            store.getters.smsCustomerId
          );
        if (response) {
          if (response) {
            let smsUserPermissions = {};
            response.filter((item) => {
              if (item.BirchCustomerUserID == store.getters.smsUserId) {
                smsUserPermissions = item;
              }
            });
            await commit("SET_SMS_USER_PERMISSIONS", smsUserPermissions);
          }
        }
      } catch (err) {
        console.warn("[vuex.user] GetUserPermissionsByBirchCustomerId", err);
        return false;
      }
    },

    GetCustomerAccessCodes: async () => {
      return store.getters.customerAccessCodes;
    },
    setReloadedBasicCustomers: async (context, value) => {
      context.commit("SET_BASIC_CUSTOMERS", value);
    },
    setMasterItems: async (context, value) => {
      context.commit("SET_MASTER_ITEMS", value);
    },
    Reportvalue: async (context, value) => {
      context.commit("REPORT_VALUE", value);
    },
    ReferenceIdValue: async ({ commit }, value) => {
      commit("REFERENCE_ID", value);
    },
    setCustomer: async (context, value) => {
      context.commit("SET_Customer", value);
    },
    setFromDate: async (context, value) => {
      context.commit("SET_FromDate", value);
    },
    setToDate: async (context, value) => {
      context.commit("SET_ToDate", value);
    },
    setCustomerName: async (context, value) => {
      context.commit("SET_CUSTOMERNAME", value);
    },
    setToolCustomerName: async (context, value) => {
      context.commit("SET_TOOL_COMNAME", value);
    },
    setToolCustomerId: async (context, value) => {
      context.commit("SET_TOOL_CUSTOMERID", value);
    },
    setToolapiToken: async (context, value) => {
      context.commit("SET_TOOL_APITOKEN", value);
    },
    setAppSheetCustomerName: async (context, value) => {
      context.commit("SET_APPSHEET_COMNAME", value);
    },
    setAppSheetCustomerId: async (context, value) => {
      context.commit("SET_APPSHEET_CUSTOMERID", value);
    },
    setAppSheetapiToken: async (context, value) => {
      context.commit("SET_APPSHEET_APITOKEN", value);
    },
    setReportId: async (context, value) => {
      context.commit("SET_REPORTID", value);
    },
    setCompanyName: async (context, value) => {
      context.commit("SET_COMPANYNAME", value);
    },
    setCompanyNameDropdown: async (context, value) => {
      context.commit("SET_COMPANYNAMEDROPDOWN", value);
    },
    setCompanyIdDropdown: async (context, value) => {
      context.commit("SET_COMPANYIDDROPDOWN", value);
    },
    setSupportRefId: async (context, value) => {
      context.commit("SET_SUPPORT_REF_ID", value);
    },
    setAssetWizardValue: async (context, value) => {
      context.commit("SET_ASSET_WIZARD_VALUE", value);
    },
    setServiceWizardValue: async (context, value) => {
      context.commit("SET_SERVICE_WIZARD_VALUE", value);
    },
    setAssetRefreshVal: async (context, value) => {
      context.commit("SET_ASSET_REFRESH_VAL", value);
    },
    setServiceRefreshVal: async (context, value) => {
      context.commit("SET_SERVICE_REFRESH_VAL", value);
    },
    setActiveTabVal: async (context, value) => {
      context.commit("SET_ACTIVE_TAB", value);
    },
    setAssetBatchId: async (context, value) => {
      context.commit("SET_ASSET_BATCH_ID", value);
    },
    setServiceBatchId: async (context, value) => {
      context.commit("SET_SERVICE_BATCH_ID", value);
    },
    setPageNumber: async (context, value) => {
      context.commit("SET_PAGE_NUMBER", value);
    },
    setPageSize: async (context, value) => {
      context.commit("SET_PAGE_SIZE", value);
    },
    setActiveToggleVal: async (context, value) => {
      context.commit("SET_ACTIVE_TOGGLE_VAL", value);
    },
    setActiveContractsToggleVal: async (context, value) => {
      context.commit("SET_ACTIVE_CONTRACTS_TOGGLE_VAL", value);
    },
    // RamaSneha,
    setPlanningSheetObj: async (context, value) => {
      context.commit("SET_PLANNING_SHEET_OBJ", value);
    },
    setSMSCNum: async (context, value) => {
      context.commit("SET_SMS_CNUM", value);
    },
    setSMSUserPermissions: async (context, value) => {
      context.commit("SET_SMS_USER_PERMISSIONS", value);
    },
    setSMSCustomerID: async (context, value) => {
      context.commit("SET_SMS_CUSTOMER_ID", value);
    },
    setSMSUserID: async (context, value) => {
      context.commit("SET_SMS_USER_ID", value);
    },

    setStoreReserveSMSStepVal: async (context, value) => {
      context.commit("SET_RESERVE_SMS_STEP_VAL", value);
    },
    setStoreProjectionID: async (context, value) => {
      context.commit("SET_STORE_PROJECTION_ID", value);
    },
    setStoreProjectionItemEquipment: async (context, value) => {
      context.commit("SET_STORE_PROJECTION_ITEM_EQUIPMENT", value);
    },

    setStoreProjectionItemID: async (context, value) => {
      context.commit("SET_STORE_PROJECTION_ITEM_ID", value);
    },
    setStoreReserveType: async (context, value) => {
      context.commit("SET_STORE_RESERVE_TYPE", value);
    },
    setShowSMSLeftNav: async (context, value) => {
      context.commit("SET_SHOW_SMS_LEFT_NAV", value);
    },
    setProfilePicture: async (context, value) => {
      context.commit("SET_PROFILE_PICTURE", value);
    },
    setPlanningSheetTab: async (context, value) => {
      context.commit("SET_PLANNING_SHEET_TAB", value);
    },
    setPlanningSheetTabPrev: async (context, value) => {
      context.commit("SET_PLANNING_SHEET_TAB_PREV", value);
    },
    setServiceModuleStepModel: async (context, value) => {
      context.commit("SET_SERVICE_MODULE_STEP_MODEL", value);
    },
    // setCreatedSheetObj: async (context, value) => {
    //   context.commit("SET_CREATED_SHEET_OBJ", value);
    // },
    // setFinalImageDesc: async (context, value) => {
    //   context.commit("SET_FINAL_IMAGE_DESC", value);
    // },
    // setEquipImgDetails: async (context, value) => {
    //   context.commit("SET_EQIP_IMG_DETAILS", value);
    // },
    setReviewImage: async (context, value) => {
      context.commit("SET_IS_REVIEW_IMAGE", value);
    },
    setServiceTemplateDetails: async (context, value) => {
      context.commit("SET_SERVICE_TEMPLATE_DETAILS", value);
    },
    setServiceRecordsToggle: async (context, value) => {
      context.commit("SET_SERVICE_RECORDS_TOGGLE", value);
    },
    setprojectionRoute: async (context, value) => {
      context.commit("SET_PROJECTION_ROUTE", value);
    },
    setSuggestedProjectionItemID: async (context, value) => {
      context.commit("SET_SUGGESTED_PROJECTION_ITEM_ID", value);
    },
    setCopyOfProjectionName: async (context, value) => {
      context.commit("SET_COPY_PROJECTION_NAME", value);
    },
    setSMSCustomerLinkingId: async (context, value) => {
      context.commit("SET_CUSTOMER_LINKING_ID", value);
    },
    setSMSBirchLinkingId: async (context, value) => {
      context.commit("SET_BIRCH_LINKING_ID", value);
    },
    setsmsAuthToken: async (context, value) => {
      context.commit("SET_SMS_ACCESS_TOKEN", value);
    },
    setAccessTabVal: async (context, value) => {
      context.commit("SET_ACCESS_TAB_VAL", value);
    },
    setSmsOrderBy: async (context, value) => {
      context.commit("SET_SMS_ORDER_BY", value);
    },
    setSmsPickedUpBy: async (context, value) => {
      context.commit("SET_SMS_PICKEDUP_BY", value);
    },
    setShift: async (context, value) => {
      context.commit("SET_SHIFT", value);
    },
    setDeliveryRequired: async (context, value) => {
      context.commit("SET_DELIVERY_REQUIRED", value);
    },
    GetUserInfo: async () => {
      try {
        const response = false;

        // Since mockjs does not support custom status codes, it can only be hacked like this
        if (!response) {
          throw new Error("Verification failed, please login again.");
        }

        // Verify returned roles are a non-null array
        if (
          response.data.userAccount.role &&
          response.data.userAccount.role.length === 0
        ) {
          throw new Error("getInfo: roles must be a non-null array!");
        }

        //commit('SET_USER_INFO', response.user);
      } catch (err) {
        console.warn("[vuex.user] GetUserInfo", err);
      }
    },
    LogOut: async ({ commit }) => {
      try {
        // await commit("SET_MASTER_ITEMS", []);
        await commit("SET_USER_INFO", { logout: true });
        // console.log(store.state.user.permissions);
      } catch (err) {
        console.warn("[vuex.user] LogOut", err);
      }
    },
  },
};

export default user;
